import { Controller } from "@hotwired/stimulus"

const COLLAPSED_LINES = 10

export default class extends Controller {
  static targets = ["quote", "toggle"]

  connect() {
    this.expanded = false
    this.#checkOverflow()
  }

  toggle() {
    this.expanded = !this.expanded
    if (this.expanded) {
      this.quoteTarget.classList.remove(`line-clamp-${COLLAPSED_LINES}`)
      this.toggleTarget.textContent = "Read less"
    } else {
      this.quoteTarget.classList.add(`line-clamp-${COLLAPSED_LINES}`)
      this.toggleTarget.textContent = "Read more"
    }
  }

  #checkOverflow() {
    requestAnimationFrame(() => {
      const el = this.quoteTarget
      if (el.scrollHeight > el.clientHeight) {
        this.toggleTarget.classList.remove("hidden")
      }
    })
  }
}
